import { PageHeader } from '@/components/shell/page-header';
import { createFileRoute } from '@tanstack/react-router';
import { GitBranch, Route as RouteIcon, Split } from 'lucide-react';

export const Route = createFileRoute('/_authed/journeys')({ component: JourneysPage });

function JourneysPage(): React.JSX.Element {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Journeys"
        description="Coordinate experiences across screens, events, and customer milestones."
      />
      <section className="border-y py-14">
        <div className="mx-auto max-w-2xl text-center">
          <span className="mx-auto grid size-11 place-items-center rounded-lg border bg-secondary/50">
            <RouteIcon className="size-5" />
          </span>
          <div className="mt-4 flex items-center justify-center gap-2">
            <h2 className="text-base font-semibold">Journey orchestration is planned</h2>
            <span className="rounded border px-1.5 py-0.5 text-[9px] font-semibold uppercase text-muted-foreground">Coming later</span>
          </div>
          <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-muted-foreground">
            The first version will connect existing experiences with event and screen transitions. Experience authoring remains in the current builder.
          </p>
          <div className="mt-8 grid gap-3 text-left sm:grid-cols-2">
            <PlannedCapability icon={GitBranch} title="Branching paths" description="Move customers based on events and audience state." />
            <PlannedCapability icon={Split} title="Flow controls" description="Wait, branch, and hand off between mobile moments." />
          </div>
        </div>
      </section>
    </div>
  );
}

function PlannedCapability({ icon: Icon, title, description }: { icon: typeof GitBranch; title: string; description: string }): React.JSX.Element {
  return (
    <div className="rounded-lg border p-4">
      <Icon className="size-4 text-muted-foreground" />
      <p className="mt-3 text-sm font-medium">{title}</p>
      <p className="mt-1 text-xs leading-5 text-muted-foreground">{description}</p>
    </div>
  );
}

